import { useEffect, useState, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { AppProvider } from '@toolpad/core/react-router-dom';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { auth } from './firebase';
import { useNavigate } from 'react-router-dom';
import { createTheme } from '@mui/material';
import { jwtDecode } from 'jwt-decode';
import logo from './images/saleng shop white.png';
import { useLocation } from "react-router-dom";


const theme = createTheme({
  typography: {
    fontFamily: '"IBM Plex Sans Thai", serif',
  },
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: { light: true },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#042CA6',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: '#FFEA4E',
            '&:hover': {
              backgroundColor: '#FFD700', // สีเมื่อ selected และ hover
            },
          },
          // '&.Mui-selected .MuiSvgIcon-root': {
          //   color: '#FFFFFF', // Change the color of the icon when selected
          // },
        },
      },
    },
    // MuiSvgIcon: {
    //   styleOverrides: {
    //     root: {
    //       color: '#FFFFFF', // Default color for all icons
    //     },
    //   },
    // },
  }
});

export default function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const firstSegment = pathSegments[0];

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      try {
        const decoded = jwtDecode(accessToken);

        // ตรวจสอบเวลาหมดอายุ (exp) กับเวลาปัจจุบัน
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          console.log("Token has expired");
          navigate('/auth/login');
        } else {
          console.log("Token is still valid");
          setSession({
            user: {
              name: decoded.username,
              email: decoded.username + "@gmail.com",
              // image: <AccountCircleIcon />,
            },
          });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate('/auth/login');
      }
    } else {
      console.log("No access token found");
      if (firstSegment != 'receipt') {
        navigate('/auth/login');
      }

    }
  }, [navigate]);

  const [session, setSession] = useState({});

  const authentication = useMemo(() => {
    return {
      signIn: () => {
        setSession({
          user: {
            name: '',
            email: '',
            image: <AccountCircleIcon />,
          },
        });
      },
      signOut: async () => {
        await auth.signOut();
        localStorage.removeItem('accessToken');
        setSession(null);
        navigate('/auth/login');
      },
    };
  }, [navigate]);

  return (
    <AppProvider
      theme={theme}
      session={session}
      authentication={authentication}
      branding={{
        logo: <img src={logo} alt="SALENG Shop Logo" />,
        title: 'POS'
        // title: <p style={{ color: "#FFF", marginTop: '18px' }}>ADMIN</p>
        // homeUrl: '/toolpad/core/introduction',
      }}
    >
      <Outlet />
    </AppProvider>
  );
}